<script lang="ts">
    import type {Document} from 'typings/portaro.be.types';
    import {getInjector} from 'core/svelte-context/context';
    import {ThreadsService} from 'src/features/threads/services/threads.service';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import ThreadContent from 'src/features/threads/shared-components/ThreadContent.svelte';

    export let record: Document;

    const threadService = getInjector().getByClass(ThreadsService);

    let creatingThread = false;
    let threadCreated = false;

    const handleCreateThreadClick = async () => {
        creatingThread = true;
        const thread = await threadService.createRecordThread(record);
        creatingThread = false;
        threadCreated = true;

        record.threadId = thread.id;
    };
</script>

{#if !record.threadId && !threadCreated}
    <div class="create-thread-container">
        <IconedContent icon="messages" orientation="vertical" align="center" justify="center">
            Pro tento záznam ještě neexistuje žádná konverzace
        </IconedContent>

        <KpButton buttonStyle="success-new" isDisabled="{creatingThread}" on:click={handleCreateThreadClick}>
            <IconedContent icon="add">
                Vytvořit konverzaci
            </IconedContent>
        </KpButton>
    </div>
{/if}

{#if threadCreated || record.threadId}
    <ThreadContent placement="fullscreen-page"/>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro-erp.less";

    .create-thread-container {
        .flex-grow();
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: @spacing-ml;
        margin-bottom: 100px;
    }
</style>